export default () => ({
    text: {
        fontSize: '0.65rem',
        lineHeight: 2.2,
        maxHeight: 150,
        overflow: 'auto'
    }
});
